import React, {createContext, useState} from 'react';
import PropTypes from 'prop-types';
import noop from '../../../utils/noop';
import ErrorModal from '../components/ErrorModal';

const Context = createContext({
  onError: noop,
  error: {},
});

export default Context;

export const ErrorModalProvider = ({children}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState({});

  const onError = e => {
    setError(e);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setError({});
  };

  return (
    <Context.Provider value={{onError}}>
      {children}
      <ErrorModal isOpen={isOpen} close={closeModal} error={error} />
    </Context.Provider>
  );
};

ErrorModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
